import Drawer from "../drawer/Drawer.jsx";
import colorSchema from "../../assets/kits/colors";
import useWindowSize from "../../hooks/useWindowSize.jsx";
import { addCommas } from "@persian-tools/persian-tools";
import { CloseIcon } from "../kits/Icons/Icons.tsx";

import "./orders.scss";

export default function OrderDrawer({
  isOpen,
  setIsOpen,
  items,
  delivery,
  discount,
}) {
  const winSize = useWindowSize();
  const sumPrices = () => {
    let sum = 0;
    for (let i = 0; i < items.length; i++) {
      sum = sum + +items[i].total_amount;
    }

    return sum;
  };
  /* factor drawer*/


  return (
    <Drawer
      height={winSize.height > items.length * 37 + 200 ? "auto" : Infinity}
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <div className="pd-b-24 mr-t-16">
        <div className="d-flex justify-content-between mr-x-20">
          <h3
            className="title-h3-b  "
            style={{ color: colorSchema.foreground_background_he }}
          >
            فاکتور
          </h3>
          {winSize.height < items.length * 37 + 320 && (
            <button
              className="btn"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <CloseIcon className="txt-t1-l fs-3 " />
            </button>
          )}
        </div>
        {items.map((value) => {
          return (
            <div className="d-flex justify-content-between mr-x-20 mr-t-16">
              <div
                className="txt-t2-l d-flex "
                style={{ color: colorSchema.foreground_background_me }}
              >
                <span className="productTitle">{value.title}</span>
                <span className="d-flex" style={{ whiteSpace: "nowrap" }}>
                  {" "}
                  ({value.item_count} عدد)
                </span>
              </div>
              <div
                className="txt-t2-l mr-r-32"
                style={{
                  color: colorSchema.foreground_background_me,
                  whiteSpace: "nowrap",
                }}
              >
                {addCommas((+value.price - value.discount) * +value.item_count)}{" "}
                تومان
              </div>
            </div>
          );
        })}
        <hr
          className="mr-20"
          style={{ color: colorSchema.foreground_background_me }}
        />
        <div
          className="d-flex justify-content-between mr-x-20 "
          style={{ color: colorSchema.foreground_background_me }}
        >
          <div className="txt-t2-l">مبلغ اقلام</div>
          <div className="txt-t2-l">{addCommas(sumPrices())} تومان</div>
        </div>
        <div
          className="d-flex justify-content-between mr-x-20 mr-t-16"
          style={{ color: colorSchema.foreground_background_me }}
        >
          <div className="txt-t2-l">هزینه پیک</div>
          <div className="txt-t2-l">
            {delivery == "0" ? "رایگان" : `${addCommas(delivery)} تومان`}
          </div>
        </div>
        <hr
          className="mr-x-20 mr-t-20 mr-b-16"
          style={{ color: colorSchema.foreground_background_me }}
        />
        <div
          className="d-flex justify-content-between mr-x-20 mr-t-16"
          style={{ color: colorSchema.foreground_background_me }}
        >
          <div className="txt-t2-l">قابل پرداخت</div>
          <div className="txt-t2-l">
            {addCommas(sumPrices() - discount + +delivery)} تومان
          </div>
        </div>
      </div>
    </Drawer>
  );
}
